/**
 * Event Request Journey Configuration
 *
 * Defines the event request flow: association-info → summary → complete
 * Uses REQUEST availability type defaults with EVENT-specific overrides for complete page.
 */

import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { CheckoutJourney } from '../models/checkout-journey.types';
import { BookingTypeName } from '@shared/models/enums';
import { CheckoutStore } from '../checkout.store';

export const EVENT_REQUEST_JOURNEY: CheckoutJourney = {
  type: BookingTypeName.EVENT,
  searchRoute: '/associations/event-request', // Base search route for event request journey
  page: [
    {
      pageRoute: 'association-info',
      label: 'Foreningsinfo',
      ariaLabel: 'Foreningsinfo',
    },
    {
      pageRoute: 'summary',
      label: 'Oversigt',
      ariaLabel: 'Oversigt',
      zoneConfig: {
        // Override only title - keeps message and illustrationPath from availabilityType config
        summaryContent: {
          title: 'Din forespørgsel på arrangement er sendt', // Journey-specific title
        },
        // Override: EVENT-specific actions for summary page
        actions: [
          {
            id: 'submit', // action defined in availability Type
            buttonLabel: 'Anmod om arrangement', // Journey-specific label overrride
          },
        ],
      },
      canActivate: () => {
        const store = inject(CheckoutStore);
        return !!store.bookingId();
      },
    },
    {
      pageRoute: 'complete',
      label: 'Forespørgsel Gennemført',
      ariaLabel: 'Forespørgsel gennemført',
      zoneConfig: {
        // Override only title - keeps message and illustrationPath from availabilityType config
        summaryContent: {
          title: 'Din forespørgsel på arrangement er sendt', // 🎯 Journey-specific title
        },
        // Override: EVENT-specific actions for complete page
        actions: [
          {
            id: 'primary-action',
            buttonLabel: 'Anmod om nyt arrangement',
            buttonType: 'filled',
            action: 'custom',
            callback: async () => {
              const router = inject(Router);
              await router.navigate([EVENT_REQUEST_JOURNEY.searchRoute]);
            },
          },
        ],
      },
    },
  ],
};
